import React from 'react';
import CloseIcon from '@/../wwwroot/images/icons/close-toast-white.svg?react';

import { CircleSpinner } from '@/components/Icons';
import { FilePreview } from '@/hooks/upload-files/FilePreview';
import { FileEntity } from '@/hooks/upload-files/types';

type FileUploadBoxProps = {
    onRemoveCallback?: (fileIdentifier: string) => void;
    fileEntity: FileEntity;
    disableRemove?: boolean;
};

export const FileUploadBox = ({
    fileEntity,
    onRemoveCallback,
    disableRemove = false,
}: FileUploadBoxProps) => {
    const handleRemoveFile = async () => {
        onRemoveCallback?.(fileEntity.identifier);
    };

    const shouldShowRemoveButton =
        !disableRemove && (fileEntity.isUploaded || fileEntity.isFailed);

    return (
        <div className="relative">
            {shouldShowRemoveButton && (
                <button
                    className="absolute right-0 top-0 rounded-full bg-black"
                    onClick={(e) => {
                        handleRemoveFile?.();
                    }}
                >
                    <CloseIcon className="text-gray-400 z-10 h-5 w-5" />
                </button>
            )}
            {fileEntity.isPending && (
                <div className="absolute z-20 m-auto h-full w-full rounded-lg bg-black bg-opacity-20">
                    <div className={'m-auto scale-50'}>
                        <CircleSpinner className="animate-spin fill-action-progress" />
                    </div>
                </div>
            )}
            <FilePreview fileEntity={fileEntity} />
        </div>
    );
};
